import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBathMan1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bath-man-1, man, male"><path d="M12 1C10.3431 1 9 2.34315 9 4C9 5.65685 10.3431 7 12 7C13.6569 7 15 5.65685 15 4C15 2.34315 13.6569 1 12 1Z" fill="currentColor"/><path d="M9.75 8C7.67893 8 6 9.67893 6 11.75V15.25C6 16.2165 6.7835 17 7.75 17H8V21.25C8 22.2165 8.7835 23 9.75 23H14.25C15.2165 23 16 22.2165 16 21.25V17H16.25C17.2165 17 18 16.2165 18 15.25V11.75C18 9.67893 16.3211 8 14.25 8H9.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBathMan1;
